import type { ReactElement } from 'react';
import { TextField } from '@ff-it/form';
import type { ActivityType, ProductKind } from 'types';
import { CategoryField } from 'modules/supplier/category/MediaCategoryField';
import { ProductKindFields } from './ProductFields';
import type { ProductFormConfig } from './types';

export type ProductBaseFieldsProps = {
  type: ActivityType;
  kind: ProductKind | null;
  vendorId: number | null;
  config?: ProductFormConfig;
  showServiceGrossPrice?: boolean;
};

function nameHelp(kind: ProductKind | null, type: ActivityType): string {
  if (kind === 'MEDIA' && type === 'OOH') return 'Physical location for individual objects';
  if (kind === 'MEDIA' && type === 'PRESS') return 'Position; include cover or depth here when it affects the price';
  return 'Blank for generic';
}

/**
 * Common product identity and kind-owned fields. Outlet and price-list
 * wrappers supply their own context fields and submit/mutation behavior.
 */
export function ProductBaseFields({
  type,
  kind,
  vendorId,
  config,
  showServiceGrossPrice,
}: ProductBaseFieldsProps): ReactElement {
  const baseFieldClass = 'col-12';
  return (
    <>
      <div className="form-row">
        <TextField name="name" label="Name" className={baseFieldClass} help={nameHelp(kind, type)} />
        <CategoryField name="category" label="Category" className={baseFieldClass} help="Leave empty to inherit" />
      </div>
      {kind && (
        <ProductKindFields
          kind={kind}
          type={type}
          vendorId={vendorId}
          config={config}
          showServiceGrossPrice={showServiceGrossPrice}
        />
      )}
    </>
  );
}
